import Schedules from './Schedules';

export default Schedules;
